import { SearchDateHistotyReducer } from "../reducer/SearchDateHistoryReducer";

export const reducer = SearchDateHistotyReducer;
